export default "__VITE_ASSET__BJk$C2aA__"